export default __webpack_public_path__ + "static/media/background_code.958fc3ec.png";